module.exports = function (value, _options) {
  if (this.switch_break === false) {
    return value;
  }
  return undefined;
};
